// Maabar contact — WhatsApp is the human channel for the managed-order concierge.
// The trader taps a button that opens WhatsApp with the order ref pre-filled; the
// admin gets the trader's number as a wa.me link to reach out.
export const MAABAR_WHATSAPP = '966554064679';   // Maabar Business (Saudi, intl format)

// The iOS listing. Lives here rather than in a component because two now link to
// it — Home's app banner and the footer's store buttons — and the app id is one
// of Maabar's outward-facing identifiers, not a page's detail.
export const APP_STORE_URL = 'https://apps.apple.com/sa/app/maabar-%D9%85%D8%B9%D8%A8%D8%B1/id6780046671';

/**
 * Maabar's commercial registration number — the company's own, and a PUBLIC
 * LEGAL IDENTIFIER. Not to be confused with a supplier's `reg_number`, which is
 * a different company's and lives on their profile.
 *
 * ⚠️ IT LIVES HERE BECAUSE IT WAS WRONG IN TWO PLACES AT ONCE (2026-09-20).
 * `Footer.jsx` and `Terms.jsx` each declared their own `const CR_NUMBER`, both
 * holding a value the owner confirmed was incorrect. Correcting only the one
 * that had been reported would have left the WRONG number on the Terms &
 * Conditions page -- the more legally consequential of the two -- with nothing
 * to indicate it disagreed with the footer directly beneath it.
 *
 * One constant, imported. If a third surface needs it (an invoice, a PDF, an
 * email footer), import it; do not retype it. A legal identifier copied by hand
 * is a legal identifier that will be wrong somewhere.
 *
 * Digits are ASCII and must render ASCII in all three languages. Where it is
 * shown inside Arabic text, isolate it (`dir="ltr"`) so the punctuation touching
 * it is not reordered by the bidi algorithm -- see Footer.jsx's Num component.
 */
export const MAABAR_CR_NUMBER = '7055105253';

const intl = (phone) => {
  const d = String(phone || '').replace(/[^\d]/g, '');
  if (!d) return '';
  if (d.startsWith('966')) return d;
  if (d.startsWith('0')) return '966' + d.slice(1);     // 05xxxxxxxx → 9665xxxxxxxx
  if (d.length === 9 && d.startsWith('5')) return '966' + d;  // 5xxxxxxxx
  return d;
};

// Link to message MAABAR (trader → concierge).
export function waLink(text) {
  return `https://wa.me/${MAABAR_WHATSAPP}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}

// Link to message a given number (admin → trader). Returns '' for an empty number.
export function waTo(phone, text) {
  const n = intl(phone);
  return n ? `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ''}` : '';
}
